import React, { useState } from "react";
import { HiX } from "react-icons/hi";

function TaskUpdates({ task, onClose }) {
  //States for pagination
  const [currentPageOfPendingTasks, setCurrentPageOfPendingTasks] = useState(1);
  const [currentPageOfCompletedTasks, setCurrentPageOfCompletedTasks] =
    useState(1);

  //Function to format date and time
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true, // Ensures 24-hour format
      })
      .replace(/\//g, "-"); // Replace "/" with "-"
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm backdrop-brightness-75"
      onClick={onClose}
    >
      <div
        className="relative h-[80%] w-[95%] max-w-3xl overflow-y-auto rounded-lg bg-white p-4 shadow-lg md:p-8 lg:h-auto lg:px-6 lg:py-8"
        onClick={(e) => e.stopPropagation()}
      >
        <HiX
          className="absolute right-4 top-4 cursor-pointer text-primary hover:text-red-500"
          size={20}
          onClick={onClose}
        />

        <h1 className="my-2 text-center text-3xl font-bold tracking-wide text-primary">
          Task Updates
        </h1>

        <div className="grid grid-cols-2 ">
          <p className=" mb-2 text-lg">
            Task Name :{" "}
            <span className="font-semibold text-primary">{task.name}</span>
          </p>
          <p className=" mb-2 text-lg">
            Task Status :{" "}
            <span
              className={`rounded-xl p-2 px-4 font-semibold ${
                task?.status === "Pending"
                  ? "bg-yellow-100 text-yellow-700"
                  : task.status === "Ongoing"
                  ? "bg-blue-100 text-blue-700"
                  : task.status === "Completed"
                  ? "bg-green-100 text-green-700"
                  : ""
              }`}
            >
              {task.status}
            </span>
          </p>
        </div>

        {task.status === "Pending" ? (
          <p className="col-span-2 my-2 text-center tracking-wide text-gray-500">
            Updates are available only in ongoing or completed tasks
          </p>
        ) : (
          <div className="grid grid-cols-1 justify-between text-lg md:grid-cols-2 ">
            {/* Task Start Date & Time */}
            <p className="mb-2">
              Started at :{" "}
              <span className="text-primaryText">
                {task?.updates?.startTime
                  ? formatDate(task?.updates?.startTime)
                  : "Task not started"}
              </span>
            </p>

            {/* Task End Date & Time */}
            <p className="mb-2">
              Ended at :{" "}
              <span className="text-primaryText">
                {task?.updates?.endTime
                  ? formatDate(task?.updates?.endTime)
                  : "Task not ended"}
              </span>
            </p>

            {/* Task Start Note */}
            <p className="mb-2">
              Start Note :{" "}
              <span className="font-medium tracking-wide text-gray-800">
                {task?.updates?.reports?.startReport || (
                  <span className="text-sm font-thin italic tracking-wider text-gray-500">
                    No Start Note
                  </span>
                )}
              </span>
            </p>

            {/* Task End Note */}
            <p className="mb-2">
              End Note :{" "}
              <span className="font-medium tracking-wide text-gray-800">
                {task?.updates?.reports?.endReport || (
                  <span className="text-sm font-thin italic tracking-wider text-gray-500">
                    No End Note
                  </span>
                )}
              </span>
            </p>
            {/* Task Start Images */}
            <div>
              <span className="mb-2">Task Start Images : </span>
              <div className="my-4 flex flex-wrap gap-4">
                {task?.updates?.reports?.startImages?.length > 0 ? (
                  task?.updates?.reports?.startImages?.map((image, index) => (
                    <a href={image} key={index} target="_blank">
                      <img src={image} alt="" className="w-1/5 rounded " />
                    </a>
                  ))
                ) : (
                  <span className="text-sm italic tracking-wider text-gray-500">
                    No Start Images
                  </span>
                )}
              </div>
            </div>

            {/* Task End Images */}
            <div>
              <span className="mb-2">Task End Images : </span>
              <div className="my-4 flex flex-wrap gap-4">
                {task?.updates?.reports?.endImages?.length > 0 ? (
                  task?.updates?.reports?.endImages?.map((image, index) => (
                    <a href={image} key={index} target="_blank">
                      <img src={image} alt="" className="w-1/5 rounded" />
                    </a>
                  ))
                ) : (
                  <span className="text-sm italic tracking-wider text-gray-500">
                    No End Images
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TaskUpdates;
